// extracted by mini-css-extract-plugin
export default {"block":"EditPricesListElement_block__hPTQ2"};